import { Link2 } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

interface DependencyBadgeProps {
  count: number
  onClick?: () => void
  className?: string
}

/**
 * Phase 13 — small "depends on N" pill on `<StepRow>` and the doing-view's blocked rows. Click
 * opens the editor's `<DependencyPicker>`; in the doing view the doer doesn't get a click handler
 * and the badge is informational only.
 */
export const DependencyBadge = ({ count, onClick, className }: DependencyBadgeProps) => {
  if (count <= 0) return null
  const label = `depends on ${count}`
  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cn(
          'inline-flex items-center gap-1 rounded-full border border-border bg-secondary px-2 py-0.5 text-xs text-secondary-foreground transition-colors hover:bg-accent',
          className
        )}
        aria-label={`Edit dependencies (${label})`}
      >
        <Link2 className="h-3 w-3" aria-hidden />
        {label}
      </button>
    )
  }
  return (
    <Badge variant="secondary" className={cn('inline-flex items-center gap-1 text-xs', className)}>
      <Link2 className="h-3 w-3" aria-hidden />
      {label}
    </Badge>
  )
}
